import type { ICreateDocumentProcessParams, IDocumentProcess, IGetDocumentProcessesParams, IUpdateDocumentRequestParams } from '@condo/domain';
import { getClient } from './api-client';

export const createDocumentProcess = async (data: ICreateDocumentProcessParams): Promise<IDocumentProcess[]> => {
    return getClient('basecamp')
        .post(`/document-processes`, data)
        .then(response => response.data?.documentProcesses ?? []);
};

export const fetchDocumentProcesses = async (params?: IGetDocumentProcessesParams): Promise<IDocumentProcess[]> => {
    return getClient('basecamp')
        .get('/document-processes', { params })
        .then(response => response.data?.documentProcesses ?? []);
};

export const updateDocumentProcess = async (data: IUpdateDocumentRequestParams): Promise<IDocumentProcess[]> => {
    return getClient('basecamp')
        .post(`/document-processes`, data)
        .then(response => response.data?.documentProcesses ?? []);
};
